import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * GetValidCriteriaName
 *
 * Verifies whether the common criteria name exists or not from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetValidCriteriaName = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/criteria/validate-unique/${thePayload?.name}`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Criteria/api/requests/queries/GetValidCriteriaName.js -> GetValidCriteriaName()',
      false,
      error
    );

    throw error;
  }
};
